import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
  },
  header: {
    height: 64,
    position: 'relative',
    padding: 24,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  backButton: {
    left: 10,
    position: 'absolute',
  },
  tabs: {
    boxShadow: '0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)',
    position: 'relative',
    zIndex: 90,
    padding: [0, 28, 0, 28],
  },
  tab: {
    minWidth: 'unset',
    marginRight: 32,
  },
  content: {
    padding: [32, 28, 0, 28],
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/MobileMessages/components/LoanOfficerPage/useStyles.js